function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var __defProp = Object.defineProperty;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __publicField = function(obj, key, value) {
    __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/pubsub-signal-manager.ts
var PubSubSignalManager = /*#__PURE__*/ function() {
    "use strict";
    function PubSubSignalManager() {
        _class_call_check(this, PubSubSignalManager);
        __publicField(this, "subscribers", /* @__PURE__ */ new Map());
    }
    _create_class(PubSubSignalManager, [
        {
            key: "getOrCreateSubscribers",
            value: function getOrCreateSubscribers(topic) {
                if (topic && this.subscribers.has(topic)) {
                    return this.subscribers.get(topic);
                }
                return this.subscribers.set(topic, /* @__PURE__ */ new Map()).get(topic);
            }
        },
        {
            key: "getSubscribers",
            value: function getSubscribers(topic) {
                if (topic && this.subscribers.has(topic)) {
                    return this.subscribers.get(topic);
                }
            }
        },
        {
            key: "publish",
            value: function publish(signal) {
                var subscribersByTopic = this.subscribers.get(signal.topic);
                subscribersByTopic === null || subscribersByTopic === void 0 ? void 0 : subscribersByTopic.forEach(function(callbacks, subscription) {
                    setTimeout(function() {
                        try {
                            callbacks.onSuccess(signal, subscription);
                        } catch (error) {
                            var _callbacks_onError;
                            (_callbacks_onError = callbacks.onError) === null || _callbacks_onError === void 0 ? void 0 : _callbacks_onError.call(callbacks, signal, error);
                        }
                    }, 0);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(topic, SignalType, callbacks) {
                var _this = this;
                var subscribersByTopic = this.getOrCreateSubscribers(topic);
                var subscription = {
                    SignalType: SignalType,
                    unsubscribe: function() {
                        return _this.unsubscribe(topic, subscription);
                    }
                };
                if (subscribersByTopic) {
                    subscribersByTopic.set(subscription, callbacks);
                }
                return subscription;
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(topic, subscription) {
                var subscribersByTopic = this.subscribers.get(topic);
                if (subscribersByTopic === null || subscribersByTopic === void 0 ? void 0 : subscribersByTopic.has(subscription)) {
                    subscribersByTopic.delete(subscription);
                }
            }
        }
    ]);
    return PubSubSignalManager;
}();
export { PubSubSignalManager };
//# sourceMappingURL=index.js.map